import formatTableJson from '@/config/tableComponentParams.js'
import i18n from '@/locales'
export default formatTableJson([
  {
    filed: 'deviceCode',
    label: i18n.t('Fota.deviceCode')
  },
  {
    filed: 'version',
    label: i18n.t('Fota.firmwareVersion')
  },
  {
    filed: 'productModel',
    label: i18n.t('Fota.firmwareModel')
  }
  // {
  //   filed: 'hardwareModel',
  //   label: i18n.t('Fota.hardwareModel')
  // }
  // {
  //   filed: 'remark',
  //   label: i18n.t('Fota.otherInfo')
  // }
])
